import axios from 'axios'

// ------------------------------------
// Constants
// ------------------------------------
export const FORGOT_PASSWORD_INITIAL = 'FORGOT_PASSWORD_INITIAL'
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE'

export const CHANGE_PASSWORD_INITIAL = 'CHANGE_PASSWORD_INITIAL'
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE'

// ------------------------------------
// Actions
// ------------------------------------

export function initChangePassword () {
  return function (dispatch) {
    dispatch({ type: CHANGE_PASSWORD_INITIAL })
  }
}

export function changePassword ({ userId, password, newPassword }) {
  return function (dispatch) {
    dispatch({ type: CHANGE_PASSWORD_REQUEST })

    return axios.put(`/users/password/id/${userId}`, { password, newPassword })
      .then(response => {
        console.log(response.data)
        dispatch({ type: CHANGE_PASSWORD_SUCCESS,
          payload:response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: CHANGE_PASSWORD_FAILURE,
          payload: error
        })
      })
  }
}

export function forgotPassword (data) {
  return function (dispatch) {
    dispatch({ type: FORGOT_PASSWORD_REQUEST })
    return axios.post('/forgotpassword', data)
      .then(response => {
        dispatch({ type: FORGOT_PASSWORD_SUCCESS })
      })
      .catch(() => {
        dispatch({
          type: FORGOT_PASSWORD_FAILURE,
          payload: '查無此帳號'
        })
      })
  }
}

export function initForgotPassword () {
  return function (dispatch) {
    dispatch({ type: FORGOT_PASSWORD_INITIAL })
  }
}

export const actions = {
  changePassword,
  forgotPassword,
  initForgotPassword,
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CHANGE_PASSWORD_REQUEST]: (state, action) => ({
    ...state,
    isChangePasswordLoading: true,
    isChangePasswordSuccess: false,
    changePasswordErrorMessage: '',
  }),
  [CHANGE_PASSWORD_SUCCESS]: (state, action) => ({
    ...state,
    isChangePasswordLoading: false,
    isChangePasswordSuccess: true,
    changePasswordErrorMessage: action.payload,
  }),
  [CHANGE_PASSWORD_FAILURE]: (state, action) => ({
    ...state,
    isChangePasswordLoading: false,
    isChangePasswordSuccess: false,
    changePasswordErrorMessage: action.payload
  }),
  [CHANGE_PASSWORD_INITIAL]: (state, action) => ({
    ...state,
    isChangePasswordLoading: false,
    isChangePasswordSuccess: false,
    changePasswordErrorMessage: '',
  }),

  [FORGOT_PASSWORD_REQUEST]: (state, action) => ({
    ...state,
    isForgotPasswordLoading: true,
    isForgotPasswordSuccess: false,
    forgotPasswordErrorMessage: null,
  }),
  [FORGOT_PASSWORD_SUCCESS]: (state, action) => ({
    ...state,
    isForgotPasswordLoading: false,
    isForgotPasswordSuccess: true,
    forgotPasswordErrorMessage: '',
  }),
  [FORGOT_PASSWORD_FAILURE]: (state, action) => ({
    ...state,
    isForgotPasswordLoading: false,
    isForgotPasswordSuccess: false,
    forgotPasswordErrorMessage: action.payload,
  }),
  [FORGOT_PASSWORD_INITIAL]: (state, action) => ({
    ...state,
    isForgotPasswordLoading: false,
    isForgotPasswordSuccess: false,
    forgotPasswordErrorMessage: '',
  }),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isChangePasswordLoading: false,
  isChangePasswordSuccess: false,
  changePasswordErrorMessage: '',
  isForgotPasswordLoading: false,
  isForgotPasswordSuccess: false,
  forgotPasswordErrorMessage: null,
}

export default function passwordReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/password.js